export const typeOfCallSelectedEa = (set, get) => ({
    type_of_call_selected: "",
    setTypeOfCallSelectedEa: (type_of_call_selected) => set( type_of_call_selected ),
});



// WEBPACK FOOTER //
// ./src/store/slices/EASlice/typeOfCallSelected.js